import type { CourseModule } from "@/core/types";
import { lektionTabellen } from "./lektion-01-tabellen";
import { lektionDiagramme } from "./lektion-02-diagramme";
import { lektionAussage } from "./lektion-03-aussage";

export const modulTabellen: CourseModule = {
  id: "tabellen",
  title: "Tabellen und Diagramme",
  summary:
    "Zahlen so zeigen, dass sie im Vorbeigehen ankommen: kleine Tabellen mit echter " +
    "Kopfzeile, Diagramme, deren Typ zur Aussage passt, und Titel, die das Ergebnis nennen.",
  level: "Grundlagen",
  lessons: [lektionTabellen, lektionDiagramme, lektionAussage],
};
